<template>
  <div class="partner-layout">
    <span v-html="lang.sentences.partnerWith"></span>
    <br />
    <img
      v-for="partner in partners"
      :key="partner"
      :src="`/assets/images/partners/${partner}.png`"
      :alt="partner" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "PartnerLayout",
  props: {
    partners: {
      type: Array,
      required: true
    }
  },
  computed: {
    ...mapGetters("languages", ["lang"])
  }
};
</script>

<style lang="scss" scoped>
.partner-layout {
  @extend #{$partner-layout-font-size};
  position: absolute;
  width: 100%;
  bottom: 0;
  padding: $partner-layout-padding;
  line-height: $partner-layout-line-height;
  text-align: center;
  opacity: $partner-layout-opacity;
  img {
    max-width: $partner-layout-img-max-width;
  }
}
</style>
